import React from "react"

const RyderLivescoringHolesNin9rsView = ({
    holes,
    team1Id,
    team2Id,
    teamColors,
    hasDateToShow,
    matchDate,
    matchHour
}) => {
    return (
        <div className="matchScoresAndDate gap-2">
            <div className="flex space-x-1">
                {holes.map((h, idx) => {
                    let value = h[1]
                    const n = h[0]
                    let bg = "bg-black transition-colors"
                    let rawColor = ""

                    if (value === team1Id) {
                        bg = ""
                        rawColor = teamColors[team1Id]
                    }

                    if (value === team2Id) {
                        bg = ""
                        rawColor = teamColors[team2Id]
                    }

                    if (value === 'tie') bg = `hole-winner-tie`

                    return (
                        <div key={n} className={`holeScore ${bg}`} style={{ backgroundColor: rawColor }}>
                            {n}
                        </div>
                    )
                })}
            </div>

            {hasDateToShow && (
                <div className="w-full h-full flex items-center justify-center gap-2">
                    {matchDate && (
                        <span className="matchDate">
                            {matchDate}
                        </span>
                    )}
                    {matchHour && (
                        <span className="matchHour">
                            {matchHour}
                        </span>
                    )}
                </div>
            )}
        </div>
    )
}

export default RyderLivescoringHolesNin9rsView
